import { ShieldCheck } from "lucide-react";

export default function ElevateBadge({ variant = "pill" }) {
  if (variant === "card") {
    return (
      <div
        className="flex flex-col gap-4 rounded-2xl border border-ember/25 bg-indigo/40 p-6 backdrop-blur-sm sm:flex-row sm:items-center sm:gap-6"
        data-testid="elevate-badge-card"
      >
        <div className="flex h-16 w-40 shrink-0 items-center justify-center rounded-xl bg-paper px-4">
          <img
            src="/brand/backers/elevate-nxt.png"
            alt="ELEVATE Nxt 2026"
            className="max-h-9 w-auto max-w-full object-contain"
          />
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-overline text-ember">
            Government of Karnataka
          </p>
          <p className="mt-1 font-display text-lg text-paper">
            Backed by the ELEVATE Nxt programme · 2026
          </p>
          <p className="mt-1 text-sm text-mute">
            A deep-tech grant-in-aid initiative supporting frontier AI research
            built in India.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="inline-flex items-center gap-2.5 rounded-full border border-ember/25 bg-indigo/40 px-4 py-2 backdrop-blur-sm"
      data-testid="elevate-badge"
    >
      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-ember/15 text-ember">
        <ShieldCheck size={13} />
      </span>
      <span className="font-mono text-[11px] leading-tight text-mute">
        Backed by <span className="font-medium text-paper">ELEVATE Nxt</span>{" "}
        · Govt. of Karnataka · 2026
      </span>
    </div>
  );
}
